import React, { useCallback, useState } from 'react';
import { string, oneOfType, number, func, bool } from 'prop-types';
import cx from 'classnames';

import styles from './OutlineInput.scss';

// TODO: will add disabled prop
function OutlineInput({
  id,
  placeholder,
  label,
  value,
  type,
  onChange,
  error,
  className,
  disabled,
}) {
  const [isFocused, setFocused] = useState(false);
  const [isComposing, setIsComposing] = useState(false);

  const handleCompositionChange = e => {
    const newValue = e.target.value;

    if (isComposing) {
      onChange(newValue);
      return;
    }

    if (newValue !== value) onChange(newValue);
  };

  const handleCompositionEnd = () => {
    setIsComposing(false);
  };

  const handleFocus = useCallback(() => {
    setFocused(true);
  }, []);

  const handleBlur = useCallback(() => {
    setFocused(false);
  }, []);

  return (
    <div
      className={cx(styles.root, className, {
        [styles.isFocused]: isFocused,
        [styles.hasError]: error,
      })}
    >
      <label htmlFor={id} className={styles.label}>
        {label}
      </label>
      <input
        id={id}
        type={type}
        value={value}
        placeholder={placeholder}
        className={cx(styles.input, { [styles.disabled]: disabled })}
        onCompositionStart={() => setIsComposing(true)}
        onCompositionEnd={handleCompositionEnd}
        onChange={handleCompositionChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled}
      />
      {error && <p className={styles.helperText}>{error}</p>}
    </div>
  );
}

OutlineInput.propTypes = {
  label: string.isRequired,
  onChange: func.isRequired,
  className: string,
  disabled: bool,
  error: string,
  id: string,
  placeholder: string,
  type: string,
  value: oneOfType([string, number]),
};

OutlineInput.defaultProps = {
  className: undefined,
  id: null,
  placeholder: null,
  type: 'text',
  value: '',
  error: undefined,
  disabled: false,
};

export default OutlineInput;



// WEBPACK FOOTER //
// ./app/components/fields/OutlineInput/OutlineInput.jsx